import React from 'react'
import parse from 'html-react-parser'
import Arrow from '../../images/arrow-narrow-right.svg'
import { WpMediaImage } from '../../elementor'
import { SlideT } from '../../elementor/slides-widget'

interface SlideProps {
  slide: SlideT
  img?: WpMediaImage
  slideID?: string
}

const Slide = ({ slide, img, slideID }: SlideProps ) => {
  const { heading, background_image, button_text, description, link } = slide

  const generateSlideID = () => {
    if (!slideID || !heading) return ''

    switch (heading) {
      case 'Trauma & PTSD':
        return 'trauma-' + slideID
      case 'Relationship Issues':
        return 'relationship-' + slideID
      case 'LGBTQIA+':
        return 'lbgt-' + slideID
      case 'Other conditions':
        return 'othercon-' + slideID
      default: return heading.toLocaleLowerCase() + '-' + slideID
    }
  }

  return (
    <swiper-slide>
      <div className='slide-wrapper'>
        <div className='slide-image'>
          <img src={background_image?.url} alt={background_image?.alt} />
        </div>
        <div className='slide-content'>
          <h5>{parse(heading || '')}</h5>
          <p className='paragraph slide-description'>{parse(description || '')}</p>
          {(button_text !== undefined && button_text !== null && link !== undefined) ?
          <div className='thumbnail-and-link'>
            {img && <img className='thumbnail' src={img.fileUrl} alt={img.altText} />}
            <a id={generateSlideID()} href={link.url}>{button_text}<img className='arrow' src={Arrow} alt='arrow right' /></a>
          </div>
          : null}
        </div>
      </div>
    </swiper-slide>
  )
}

export default Slide
